module.exports = __webpack_public_path__ + "static/logo-1250bf294834f9ffdb8ea687018feaa3.png";